
<template>
  <div>
    <FzgNewsPc v-if="isPc()" />
    <FzgNewsMobile v-else />
  </div>
</template>

<script>
import util from '@/assets/js/util'
import FzgNewsPc from './FzgNewsPc.vue'
import FzgNewsMobile from './FzgNewsMobile.vue'


export default {
  components: {
    FzgNewsPc,
    FzgNewsMobile
  },
  methods: {
    isPc() {
      return util.isPc()
    }
  },
}
</script>



// WEBPACK FOOTER //
// FzgNews.vue?3185c116